<!--隐私协议-->
<template>
    <div class="privacy">
        <div class="container">

            <p><strong>1.背景介绍 </strong></P>
            <p>本协议旨在明确红娘与平台之间关于账户开通/升级退款事宜的约定和责任分配，以确保双方的权益和义务得到合理保护。在账户开通/升级支付时，购买方需确认自己以阅读并理解该协议的全部内容，同意按照协议执行。</P>
            <p><strong>2.退款政策 </strong></P>
            <p>2.1 除非本协议另有约定，否则账户一经开通 /升级支付完成后不可退款。</P>
            <p>2.2 若购买方在购买前对业务流程有任何疑问，可咨询官方进行确认。一旦购买方确认支付，即代表购买方同意了红娘账户开通/升级的全部说明和规定，包括不可退款的政策。</P>
            <p>2.3 在特殊情况下，如果业务存在逻辑问题或系统方存在违约行为，购买方有权要求退款。特殊情况相关问题最终解释权归系统方所有。</P>
            <p>2.4 对于非特殊情况下的退款，包括但不限于购买方自身个人原因导致的退款请求，官方有权拒绝退款要求。</P>
            <p><strong>3.责任限制 </strong></P>
            <p>3.1 官方对于因退款而引起的一切直接或间接损失不负责任。</P>
            <p>3.2 若购买方提供的退款申请未符合要求或存在隐瞒事实的情况，官方将有权采取进一步的法律行动要求购买方承担相应的法律责任。</P>
            <p>3.3 对于购买方退款事宜的处理，官方将尽力保证公正性和合理性，但不对结果承担任何保证。</P>
            <p><strong>4.其它条款 </strong></P>
            <p>4.1 本协议的变更和解释，以官方发布的最新版木为准。</P>
            <p>4.2 若购买方在购买过程中提交虚假信息或采取其他不当手段以获取退款，官方将有权采取相应的制止措施，包括但不限于限制账户使用或采取法律手段维护自身权益。</P>
            <p>4.3 任何因本协议引起的争议，双方应通过友好协商解决。若协商不成，双方同意将争议提交至官方所在地的人民法院进行解决。</P>
            <p><strong>5.确认 </strong></P>
            <p>购买方和官方在执行本协议之前，应确认已完整阅读、理解本协议的全部内容，并在开通/升级前勾选确认已阅读协议内容。</P>
            <p>以上退费协议的完整内容，请购买方在确认前务必认真阅读，并确认自己的权益和义务。</P>

            <div class="footer">
                <p><strong>江苏爱驿站信息科技有限公司</strong></p>
            </div>
        </div>
    </div>

    <!--回到顶部-->
    <!--    <van-back-top style="background-color: #fe405f"/>-->
</template>

<style lang="scss" scoped>
.privacy{
    display: flex;
    width: 100%;
    //min-height: 300px;
    background: #F8F8F8;
    .container{
        margin: 10px 10px 20px 10px;
        padding: 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
    word-break: break-all;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
        word-break: break-all;
    }
}
</style>
<script setup lang="ts">
</script>